'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_GroupRestrictionsView$$anon$53() {
  this.aVG = null;
  this.aVH = false;
}
export { $c_Lpresto_GroupRestrictionsView$$anon$53 as $c_Lpresto_GroupRestrictionsView$$anon$53 };
$p = $c_Lpresto_GroupRestrictionsView$$anon$53.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_GroupRestrictionsView$$anon$53;
/** @constructor */
function $h_Lpresto_GroupRestrictionsView$$anon$53() {
}
export { $h_Lpresto_GroupRestrictionsView$$anon$53 as $h_Lpresto_GroupRestrictionsView$$anon$53 };
$h_Lpresto_GroupRestrictionsView$$anon$53.prototype = $p;
$p.P = (function() {
  if ((!this.aVH)) {
    this.aVG = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T6($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.aVH = true;
  }
  return this.aVG;
});
var $d_Lpresto_GroupRestrictionsView$$anon$53 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_GroupRestrictionsView$$anon$53, "presto.GroupRestrictionsView$$anon$53", ({
  Jv: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_GroupRestrictionsView$$anon$53 as $d_Lpresto_GroupRestrictionsView$$anon$53 };
//# sourceMappingURL=presto.-Group-Restrictions-View$$anon$53.js.map
